// Third-party library imports.
import React from 'react';

// Local repo imports.

export const CheckboxPaletteContext = /*#__PURE__*/React.createContext(null);
export const useCheckboxPaletteContext = () => {
  const context = React.useContext(CheckboxPaletteContext);
  if (context === undefined) {
    throw new Error('CheckboxPaletteContext must be used in <CheckboxPalette />');
  }
  return context;
};